import { Api } from '@fnv-core/http';
import {
  AppointmentType,
  RegionalOfficeModel,
  LocationFilter,
} from './interfaces';
import { IApiOptions } from '@fnv-core/http/interfaces';
import { addQueryParameters, IQueryParam, StringUtil } from '@fnv-core/utils';
import _ from 'lodash';

export class AppointmentPlannerService {
  private static baseApiUrl = '/api';
  private static defaultApiOptions: IApiOptions = { cache: true };

  // Returns an array of locations for a given appointmentType
  public static async getLocations(locationFilter: LocationFilter) {
    let url = `${this.baseApiUrl}/regiokantoor/getalloffices`;

    if (locationFilter.address !== undefined) {
      url = `${this.baseApiUrl}/regiokantoor/nearbyregionalofficesbyaddress`;
    }

    if (
      locationFilter.latitide !== undefined &&
      locationFilter.longitude !== undefined
    ) {
      url = `${this.baseApiUrl}/regiokantoor/nearbyregionaloffices`;
    }

    const queryParams: IQueryParam[] = [];

    if (locationFilter.appointmentTypeId) {
      queryParams.push({
        key: 'appointmentID',
        value: locationFilter.appointmentTypeId,
      });
    }
    if (locationFilter.latitide && locationFilter.longitude) {
      queryParams.push({ key: 'latitude', value: locationFilter.latitide });
      queryParams.push({ key: 'longitude', value: locationFilter.longitude });
    }
    if (locationFilter.address) {
      queryParams.push({ key: 'address', value: locationFilter.address });
    }

    url = addQueryParameters(url, queryParams);

    try {
      const result = await Api.get<RegionalOfficeModel[]>(
        url,
        this.defaultApiOptions
      );

      return result;
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }

  // Returns all known appointment types
  public static async getAppointmentTypes() {
    return await this.getAllAppointmentTypes();
  }

  // Returns a single appointment Type object or undefined when not found
  public static async getAppointmentTypeById(typeId: number) {
    const result = await this.getAllAppointmentTypes();

    return (
      _.find(result, (at) => {
        return at.appointmentId === typeId;
      }) ?? undefined
    );
  }

  private static async getAllAppointmentTypes() {
    const result = await Api.get<AppointmentType[]>(
      `${this.baseApiUrl}/afspraakmaken/GetAppointmentTypes`,
      this.defaultApiOptions
    );

    return result;
  }
}
